/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../Interceptor/Interseptor'
import {message} from 'antd'
import {withRouter} from 'react-router-dom'
import Loader from '../loaders/loader'
import Select from 'react-select'

class EditFamilyStatus extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      model: {
        title: '',
        enabled: 1,
        providerMandatory: 0,
        providerVisibility: 0,
        statusMandatory: 0,
        statusVisibility: 0,
        userCodeMandatory: 0,
        userCodeVisibility: 0,
        invoiceIdMandatory: 0,
        invoiceIdVisibility: 0,
        deliveryPackIdMandatory: 0,
        deliveryPackIdVisibility: 0,
        // dateTimeLabelVisibility: 0,
        // dateTimeLabelMandatory: 0,
        dateLabelVisibility: 0,
        dateLabelMandatory: 0,
        timeLabelVisibility: 0,
        timeLabelMandatory: 0,
        textLabelMandatory: 0,
        textLabelVisibility: 0,
        phoneLabelMandatory: 0,
        phoneLabelVisibility: 0,
        selectiveItemLabelMandatory: 0,
        selectiveItemLabelVisibility: 0,
        userLabelVisibility: 0,
        userLabelMandatory: 0,
        userLabel: '',
        commentLabelMandatory: 0,
        commentLabelVisibility: 0,
        dateLabel: '',
        timeLabel: '',
        textLabel: '',
        phoneLabel: '',
        selectiveItemLabel: '',
        commentLabel: '',
        sortOrder: '',
        processCategoryId: null
      },
      status: [{text: 'بله', value: 1}, {text: 'خیر', value: 0}]
    }
  }

  submit(e) {
    e.preventDefault()
  }
  componentDidMount() {
    let {id} = this.props.match.params
    this.setState({
      loading: true
    })
    Promise.all([this.getFamilyStatus(id), this.listProcessCategory()])
      .then((res) => {
        let processCategoryId = res[0].processCategoryId
        let findProcessCategory = res[1].find((item) => item.id === processCategoryId)
        if (findProcessCategory) {
          let {model} = this.state
          model['processCategoryId'] = findProcessCategory
          this.setState(
            {
              model
            },
            () => {}
          )
        }
        this.setState({loading: false})
      })
      .catch((err) => {})
    // this.getFamilyStatus(id).then(() => {

    // })
  }
  listProcessCategory = () => {
    return http
      .get(`process-category/list`, {})
      .then((res) => {
        if (res.data.error === null) {
          res.data.object.forEach((item) => {
            item.value = item.id
            item.label = item.title
          })
          this.setState({
            processCategories: res.data.object
          })
          return res.data.object
        } else {
          return []
        }
      })
      .catch(() => {})
  }
  changeProcessCategory = (processCategoryId) => {
    if (processCategoryId === null) {
      let {model} = this.state
      model['processCategoryId'] = null
      this.setState({model})
    } else {
      let {model} = this.state
      model['processCategoryId'] = processCategoryId
      this.setState({model})
    }
  }

  getFamilyStatus = (id) => {
    return http
      .get(`process/${id}/get`)
      .then((res) => {
        if (res.data.error === null) {
          const {object} = res.data
          this.setState({
            model: {
              title: object.title,
              enabled: object.enabled ? 1 : 0,
              providerMandatory: object.providerMandatory ? 1 : 0,
              providerVisibility: object.providerVisibility ? 1 : 0,
              statusMandatory: object.statusMandatory ? 1 : 0,
              statusVisibility: object.statusVisibility ? 1 : 0,
              userCodeMandatory: object.userCodeMandatory ? 1 : 0,
              userCodeVisibility: object.userCodeVisibility ? 1 : 0,
              invoiceIdMandatory: object.invoiceIdMandatory ? 1 : 0,
              invoiceIdVisibility: object.invoiceIdVisibility ? 1 : 0,
              deliveryPackIdMandatory: object.deliveryPackIdMandatory ? 1 : 0,
              deliveryPackIdVisibility: object.deliveryPackIdVisibility ? 1 : 0,

              dateLabelMandatory: object.dateLabelMandatory ? 1 : 0,
              dateLabelVisibility: object.dateLabelVisibility ? 1 : 0,
              timeLabelMandatory: object.timeLabelMandatory ? 1 : 0,
              timeLabelVisibility: object.timeLabelVisibility ? 1 : 0,

              textLabelMandatory: object.textLabelMandatory ? 1 : 0,
              textLabelVisibility: object.textLabelVisibility ? 1 : 0,
              phoneLabelMandatory: object.phoneLabelMandatory ? 1 : 0,
              phoneLabelVisibility: object.phoneLabelVisibility ? 1 : 0,
              selectiveItemLabelMandatory: object.selectiveItemLabelMandatory ? 1 : 0,
              selectiveItemLabelVisibility: object.selectiveItemLabelVisibility ? 1 : 0,
              commentLabelMandatory: object.commentLabelMandatory ? 1 : 0,
              commentLabelVisibility: object.commentLabelVisibility ? 1 : 0,

              userLabelMandatory: object.userLabelMandatory ? 1 : 0,
              userLabelVisibility: object.userLabelVisibility ? 1 : 0,
              userLabel: object.userLabel,

              dateLabel: object.dateLabel,
              timeLabel: object.timeLabel,
              textLabel: object.textLabel,
              phoneLabel: object.phoneLabel,
              selectiveItemLabel: object.selectiveItemLabel,
              commentLabel: object.commentLabel,
              sortOrder: object.sortOrder
            }
          })
          return res.data.object
        } else {
          return this.state.model
        }
      })
      .catch((err) => {})
  }

  changeField = (e) => {
    let id = e.target.id
    let value = e.target.value
    let {model} = this.state
    model[id] = value
    this.setState({
      model
    })
  }

  editFamily = () => {
    let {model} = this.state
    let processCategoryId = model.processCategoryId === null ? '' : model.processCategoryId

    if (
      model.userLabel === '' ||
      processCategoryId === '' ||
      model.title === '' ||
      model.commentLabel === '' ||
      model.selectiveItemLabel === '' ||
      model.phoneLabel === '' ||
      model.textLabel === '' ||
      model.dateLabel === '' ||
      model.timeLabel === ''
    ) {
      message.error('فیلد های ستاره دار وارد شود')
    } else {
      let {id} = this.props.match.params
      let title = document.querySelector('#title').value.trim()
      let enabled = +document.querySelector('#enabled').value
      let providerMandatory = +document.querySelector('#providerMandatory').value
      let providerVisibility = +document.querySelector('#providerVisibility').value
      let userCodeMandatory = +document.querySelector('#userCodeMandatory').value
      let userCodeVisibility = +document.querySelector('#userCodeVisibility').value
      let invoiceIdMandatory = +document.querySelector('#invoiceIdMandatory').value
      let invoiceIdVisibility = +document.querySelector('#invoiceIdVisibility').value
      let deliveryPackIdMandatory = +document.querySelector('#deliveryPackIdMandatory').value
      let deliveryPackIdVisibility = +document.querySelector('#deliveryPackIdVisibility').value

      let dateLabelVisibility = +document.querySelector('#dateLabelVisibility').value
      let dateLabelMandatory = +document.querySelector('#dateLabelMandatory').value

      let timeLabelVisibility = +document.querySelector('#timeLabelVisibility').value
      let timeLabelMandatory = +document.querySelector('#timeLabelMandatory').value

      let textLabelMandatory = +document.querySelector('#textLabelMandatory').value
      let textLabelVisibility = +document.querySelector('#textLabelVisibility').value
      let phoneLabelMandatory = +document.querySelector('#phoneLabelMandatory').value
      let phoneLabelVisibility = +document.querySelector('#phoneLabelVisibility').value
      let selectiveItemLabelMandatory = +document.querySelector('#selectiveItemLabelMandatory').value
      let selectiveItemLabelVisibility = +document.querySelector('#selectiveItemLabelVisibility').value
      let commentLabelMandatory = +document.querySelector('#commentLabelMandatory').value
      let commentLabelVisibility = +document.querySelector('#commentLabelVisibility').value

      let userLabelVisibility = +document.querySelector('#userLabelVisibility').value
      let userLabelMandatory = +document.querySelector('#userLabelMandatory').value
      let userLabel = document.querySelector('#userLabel').value.trim()

      let dateLabel = document.querySelector('#dateLabel').value.trim()
      let timeLabel = document.querySelector('#timeLabel').value.trim()
      let textLabel = document.querySelector('#textLabel').value.trim()
      let phoneLabel = document.querySelector('#phoneLabel').value.trim()
      let selectiveItemLabel = document.querySelector('#selectiveItemLabel').value.trim()
      let commentLabel = document.querySelector('#commentLabel').value.trim()
      let sortOrder = document.querySelector('#sortOrder').value
      let object = {
        title,
        enabled,
        providerMandatory,
        providerVisibility,
        userCodeMandatory,
        userCodeVisibility,
        invoiceIdMandatory,
        invoiceIdVisibility,
        deliveryPackIdMandatory,
        deliveryPackIdVisibility,
        textLabelMandatory,
        textLabelVisibility,
        phoneLabelMandatory,
        phoneLabelVisibility,
        selectiveItemLabelMandatory,
        selectiveItemLabelVisibility,
        commentLabelMandatory,
        commentLabelVisibility,
        textLabel,
        phoneLabel,
        selectiveItemLabel,
        commentLabel,
        sortOrder,
        dateLabel,
        timeLabel,
        dateLabelVisibility,
        dateLabelMandatory,
        timeLabelVisibility,
        timeLabelMandatory,
        processCategoryId: processCategoryId.id,
        userLabelVisibility,
        userLabelMandatory,
        userLabel
      }
      http
        .put(`process/${id}/update`, object, {})
        .then((res) => {
          if (res.data.error === null) {
            message.success('خانواده با موفقیت ویرایش شد.لطفا صبر کنید')
            setTimeout(() => {
              window.location.assign('/base/deliveryStatus/familyStatusChanges')
            }, 2000)
          } else {
          }
        })
        .catch((err) => {})
    }
  }

  render() {
    let {model, status} = this.state

    return (
      <div className="rtl printA4Page">
        <Loader show={this.state.loading} />
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>مدیریت فرایندها</li>
            <li>خانواده فرایند</li>
            <li>ویرایش</li>
          </ul>
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-10">
                <form className="verticalForm w-100 pb-4" onSubmit={this.submit.bind(this)}>
                  <div className="headerVertical">
                    <p>ویرایش خانواده فرایند</p>
                  </div>
                  <div className="container-fluid" style={{fontSize: '1.2em'}}>
                    <div className="row">
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>
                            دسته فرایند :‌
                            <span className="text-danger">*</span>
                          </label>
                          <Select
                            value={model.processCategoryId}
                            onChange={this.changeProcessCategory}
                            options={this.state.processCategories}
                            isMulti={false}
                            isClearable={true}
                            placeholder={''}
                            id="providerId"
                            name="providerId"
                            tabIndex="1"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>
                            عنوان :‌
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            defaultValue={model.title}
                            onChange={(e) => this.changeField(e)}
                            id="title"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>فعال :‌</label>
                          <select className="form-control" id="enabled" onChange={(e) => this.changeField(e)}>
                            {status.map((item) => (
                              <option selected={item.value === model.enabled} value={item.value}>
                                {item.text}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>نمایش فروشنده :‌</label>
                          <select
                            className="form-control"
                            id="providerVisibility"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option
                              disabled={model.providerMandatory == 1 ? true : false}
                              selected={model.providerVisibility === 0 && true}
                              value={0}
                            >
                              خیر
                            </option>
                            <option selected={model.providerVisibility === 1 && true} value={1}>
                              بله
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>الزام انتخاب فروشنده :‌</label>
                          <select className="form-control" id="providerMandatory" onChange={(e) => this.changeField(e)}>
                            <option selected={model.providerMandatory == 0} value={0}>
                              خیر
                            </option>
                            <option
                              disabled={model.providerVisibility == 0 ? true : false}
                              selected={model.providerMandatory == 1}
                              value={1}
                            >
                              بله
                            </option>
                          </select>
                        </div>
                      </div>

                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>نمایش مشتری :‌</label>
                          <select
                            className="form-control"
                            id="userCodeVisibility"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option
                              disabled={model.userCodeMandatory == 1 ? true : false}
                              selected={model.userCodeVisibility === 0 && true}
                              value={0}
                            >
                              خیر
                            </option>
                            <option selected={model.userCodeVisibility === 1 && true} value={1}>
                              بله
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>الزام انتخاب مشتری :‌</label>
                          <select className="form-control" id="userCodeMandatory" onChange={(e) => this.changeField(e)}>
                            <option selected={model.userCodeMandatory == 0} value={0}>
                              خیر
                            </option>
                            <option
                              disabled={model.userCodeVisibility == 0 ? true : false}
                              selected={model.userCodeMandatory == 1}
                              value={1}
                            >
                              بله
                            </option>
                          </select>
                        </div>
                      </div>

                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>نمایش شناسه فاکتور :‌</label>
                          <select
                            className="form-control"
                            id="invoiceIdVisibility"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option
                              disabled={model.invoiceIdMandatory == 1 ? true : false}
                              selected={model.invoiceIdVisibility === 0 && true}
                              value={0}
                            >
                              خیر
                            </option>
                            <option selected={model.invoiceIdVisibility === 1 && true} value={1}>
                              بله
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>الزام انتخاب شناسه فاکتور :‌</label>
                          <select
                            className="form-control"
                            id="invoiceIdMandatory"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option selected={model.invoiceIdMandatory == 0} value={0}>
                              خیر
                            </option>
                            <option
                              disabled={model.invoiceIdVisibility == 0 ? true : false}
                              selected={model.invoiceIdMandatory == 1}
                              value={1}
                            >
                              بله
                            </option>
                          </select>
                        </div>
                      </div>

                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>نمایش پارت تحویل :‌</label>
                          <select
                            className="form-control"
                            id="deliveryPackIdVisibility"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option
                              disabled={model.deliveryPackIdMandatory == 1 ? true : false}
                              selected={model.deliveryPackIdVisibility === 0 && true}
                              value={0}
                            >
                              خیر
                            </option>
                            <option selected={model.deliveryPackIdVisibility === 1 && true} value={1}>
                              بله
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>الزام انتخاب پارت تحویل :‌</label>
                          <select
                            className="form-control"
                            id="deliveryPackIdMandatory"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option selected={model.deliveryPackIdMandatory == 0} value={0}>
                              خیر
                            </option>
                            <option
                              disabled={model.deliveryPackIdVisibility == 0 ? true : false}
                              selected={model.deliveryPackIdMandatory == 1}
                              value={1}
                            >
                              بله
                            </option>
                          </select>
                        </div>
                      </div>

                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>نمایش تاریخ :‌</label>
                          <select
                            className="form-control"
                            id="dateLabelVisibility"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option
                              disabled={model.dateLabelMandatory == 1 ? true : false}
                              selected={model.dateLabelVisibility === 0 && true}
                              value={0}
                            >
                              خیر
                            </option>
                            <option selected={model.dateLabelVisibility === 1 && true} value={1}>
                              بله
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>الزام انتخاب تاریخ :‌</label>
                          <select
                            className="form-control"
                            id="dateLabelMandatory"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option selected={model.dateLabelMandatory == 0} value={0}>
                              خیر
                            </option>
                            <option
                              disabled={model.dateLabelVisibility == 0 ? true : false}
                              selected={model.dateLabelMandatory == 1}
                              value={1}
                            >
                              بله
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>نمایش ساعت :‌</label>
                          <select
                            className="form-control"
                            id="timeLabelVisibility"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option
                              disabled={model.timeLabelMandatory == 1 ? true : false}
                              selected={model.timeLabelVisibility === 0 && true}
                              value={0}
                            >
                              خیر
                            </option>
                            <option selected={model.timeLabelVisibility === 1 && true} value={1}>
                              بله
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>الزام انتخاب ساعت :‌</label>
                          <select
                            className="form-control"
                            id="timeLabelMandatory"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option selected={model.timeLabelMandatory == 0} value={0}>
                              خیر
                            </option>
                            <option
                              disabled={model.timeLabelVisibility == 0 ? true : false}
                              selected={model.timeLabelMandatory == 1}
                              value={1}
                            >
                              بله
                            </option>
                          </select>
                        </div>
                      </div>

                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>نمایش فیلد متنی ۱ :‌</label>
                          <select
                            className="form-control"
                            id="textLabelVisibility"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option
                              disabled={model.textLabelMandatory == 1 ? true : false}
                              selected={model.textLabelVisibility === 0 && true}
                              value={0}
                            >
                              خیر
                            </option>
                            <option selected={model.textLabelVisibility === 1 && true} value={1}>
                              بله
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>الزام انتخاب فیلد متنی ۱ :‌</label>
                          <select
                            className="form-control"
                            id="textLabelMandatory"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option selected={model.textLabelMandatory == 0} value={0}>
                              خیر
                            </option>
                            <option
                              disabled={model.textLabelVisibility == 0 ? true : false}
                              selected={model.textLabelMandatory == 1}
                              value={1}
                            >
                              بله
                            </option>
                          </select>
                        </div>
                      </div>

                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>نمایش فیلد متنی ۲ :‌</label>
                          <select
                            className="form-control"
                            id="phoneLabelVisibility"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option
                              disabled={model.phoneLabelMandatory == 1 ? true : false}
                              selected={model.phoneLabelVisibility === 0 && true}
                              value={0}
                            >
                              خیر
                            </option>
                            <option selected={model.phoneLabelVisibility === 1 && true} value={1}>
                              بله
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>الزام انتخاب فیلد متنی ۲ :‌</label>
                          <select
                            className="form-control"
                            id="phoneLabelMandatory"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option selected={model.phoneLabelMandatory == 0} value={0}>
                              خیر
                            </option>
                            <option
                              disabled={model.phoneLabelVisibility == 0 ? true : false}
                              selected={model.phoneLabelMandatory == 1}
                              value={1}
                            >
                              بله
                            </option>
                          </select>
                        </div>
                      </div>

                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>نمایش فیلد انتخابی :‌</label>
                          <select
                            className="form-control"
                            id="selectiveItemLabelVisibility"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option
                              disabled={model.selectiveItemLabelMandatory == 1 ? true : false}
                              selected={model.selectiveItemLabelVisibility === 0 && true}
                              value={0}
                            >
                              خیر
                            </option>
                            <option selected={model.selectiveItemLabelVisibility === 1 && true} value={1}>
                              بله
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>الزام انتخاب فیلد انتخابی :‌</label>
                          <select
                            className="form-control"
                            id="selectiveItemLabelMandatory"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option selected={model.selectiveItemLabelMandatory == 0} value={0}>
                              خیر
                            </option>
                            <option
                              disabled={model.selectiveItemLabelVisibility == 0 ? true : false}
                              selected={model.selectiveItemLabelMandatory == 1}
                              value={1}
                            >
                              بله
                            </option>
                          </select>
                        </div>
                      </div>

                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>نمایش توضیحات :‌</label>
                          <select
                            className="form-control"
                            id="commentLabelVisibility"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option
                              disabled={model.commentLabelMandatory == 1 ? true : false}
                              selected={model.commentLabelVisibility === 0 && true}
                              value={0}
                            >
                              خیر
                            </option>
                            <option selected={model.commentLabelVisibility === 1 && true} value={1}>
                              بله
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>الزام انتخاب توضیحات :‌</label>
                          <select
                            className="form-control"
                            id="commentLabelMandatory"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option selected={model.commentLabelMandatory == 0} value={0}>
                              خیر
                            </option>
                            <option
                              disabled={model.commentLabelVisibility == 0 ? true : false}
                              selected={model.commentLabelMandatory == 1}
                              value={1}
                            >
                              بله
                            </option>
                          </select>
                        </div>
                      </div>

                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>نمایش کاربر :‌</label>
                          <select
                            className="form-control"
                            id="userLabelVisibility"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option
                              disabled={model.userLabelMandatory == 1 ? true : false}
                              selected={model.userLabelVisibility === 0 && true}
                              value={0}
                            >
                              خیر
                            </option>
                            <option selected={model.userLabelVisibility === 1 && true} value={1}>
                              بله
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>الزام انتخاب کاربر :‌</label>
                          <select
                            className="form-control"
                            id="userLabelMandatory"
                            onChange={(e) => this.changeField(e)}
                          >
                            <option selected={model.userLabelMandatory == 0} value={0}>
                              خیر
                            </option>
                            <option
                              disabled={model.userLabelVisibility == 0 ? true : false}
                              selected={model.userLabelMandatory == 1}
                              value={1}
                            >
                              بله
                            </option>
                          </select>
                        </div>
                      </div>

                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>
                            عنوان کاربر :‌
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            defaultValue={model.userLabel}
                            onChange={(e) => this.changeField(e)}
                            id="userLabel"
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>
                            عنوان تاریخ :‌
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            defaultValue={model.dateLabel}
                            onChange={(e) => this.changeField(e)}
                            id="dateLabel"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>
                            عنوان ساعت :‌
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            defaultValue={model.timeLabel}
                            onChange={(e) => this.changeField(e)}
                            id="timeLabel"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>
                            عنوان متنی ۱ :‌
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            defaultValue={model.textLabel}
                            onChange={(e) => this.changeField(e)}
                            id="textLabel"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>
                            عنوان فیلد متنی ۲ :‌
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            defaultValue={model.phoneLabel}
                            onChange={(e) => this.changeField(e)}
                            id="phoneLabel"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>
                            عنوان فیلد قابل انتخابی :‌
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            defaultValue={model.selectiveItemLabel}
                            onChange={(e) => this.changeField(e)}
                            id="selectiveItemLabel"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>
                            عنوان فیلد توضیحات :‌
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            defaultValue={model.commentLabel}
                            onChange={(e) => this.changeField(e)}
                            id="commentLabel"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 formComponent">
                          <label>
                            ترتیب نمایش :‌
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            defaultValue={model.sortOrder}
                            onChange={(e) => this.changeField(e)}
                            id="sortOrder"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-4 col-lg-3">
                        <div className="w-100 d-flex flex-row justify-content-start">
                          <button className="btn btn-primary btn-md" onClick={this.editFamily}>
                            ویرایش
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default withRouter(EditFamilyStatus)
